import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  emoji: '🗓️',
  title: 'Gestohlene Wochenenden',
  desc: 'Du bist es leid, deine Abende mit manueller Vorbereitung zu verschwenden während andere einfach ihr System öffnen und loslegen.'
}, {
  emoji: '🔋',
  title: 'Null Energie',
  desc: 'Du kommst erschöpft von der Piste nach Hause und musst noch den nächsten Tag vorbereiten. Jeden. Einzelnen. Tag.'
}, {
  emoji: '🔄',
  title: 'Immer die gleichen Methoden',
  desc: 'Du spürst dass du immer dieselben Übungen anbietest und deine Kunden beginnen das zu merken.'
}, {
  emoji: '💰',
  title: 'Du willst mehr verdienen',
  desc: 'Du weißt dass deine Erfahrung mehr wert ist als 100 CHF pro Stunde. Aber du hast nicht die Werkzeuge um das zu beweisen.'
}];
export function ForYouChecklist() {
  return <section className="py-10 px-4 bg-brand-surface border-y border-brand-border" data-id="element-90">
      <div className="max-w-xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-92">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-navy mb-3" data-id="element-93">
            Erkennst du dich wieder?
          </h2>
        </motion.div>

        <div className="space-y-3 mb-8" data-id="element-94">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex gap-3 items-start bg-white p-4 rounded-xl border border-brand-border shadow-sm" data-id="element-95">
              <div className="text-3xl shrink-0" data-id="element-96">{item.emoji}</div>
              <div data-id="element-97">
                <h3 className="font-bold text-brand-navy mb-0.5" data-id="element-98">
                  {item.title}
                </h3>
                <p className="text-sm text-brand-muted leading-snug" data-id="element-99">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-base font-bold text-brand-gold" data-id="element-100">
          ✓ Dann wurde Swiss Champions für dich erschaffen.
        </p>
      </div>
    </section>;
}